import { Button } from '@/components/Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface CandidateMailSignatureDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isDeleting?: boolean;
}

export default function CandidateMailSignatureDeleteModal({
  open,
  onClose,
  onConfirm,
  isDeleting = false,
}: CandidateMailSignatureDeleteModalProps) {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && !isDeleting) {
      onClose();
    }
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="w-[509px] rounded p-0">
        <DialogHeader className="items-start space-y-0 px-lg! py-md!">
          <DialogTitle className="text-base! font-bold! text-main">署名の削除</DialogTitle>
        </DialogHeader>

        <div className="p-lg text-sm leading-[1.7] text-main">署名を削除してよろしいですか？</div>

        <DialogFooter className="justify-end gap-xs px-lg! py-md! sm:space-x-0!">
          <Button type="button" color="secondary" size="md" onClick={onClose} disabled={isDeleting}>
            キャンセル
          </Button>
          <Button
            type="button"
            color="danger"
            size="md"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            削除
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
